export default function() {
    const hiddenFields = {};
    const hiddenFieldsEls = document.querySelectorAll(".js-mkto-hidden-field");

    if (!hiddenFieldsEls.length === 0) return {};

    for (const hiddenField of hiddenFieldsEls) {
        const { property, value } = hiddenField.dataset;

        if (!property || !value) continue;

        hiddenFields[property] = value;
    }

    return hiddenFields;
}
